// ** React Imports
import { Fragment, useState, useContext, useEffect } from "react"
import { StoreContext } from "@customstore/StoreProvider"
import ItemDropdown from "./NotificacionDropdownComponents/ItemDropdown.jsx"

// ** Utils
import { getUserData, messageee } from '@utils'
// ** Custom Components
import Avatar from "@components/avatar"
import io from 'socket.io-client'
// ** Custom Hooks
import { useNotificacion } from "@hooks/useNotificacion"

// ** Third Party Components
import PerfectScrollbar from "react-perfect-scrollbar"
import { Bell, X, Check, AlertTriangle } from "react-feather"
import { types } from '@customstore/storeReducer'

// ** Reactstrap Imports
import {
  Badge,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap"
import { useNavigate } from "react-router-dom"

const NotificationDropdown = () => {
  const [store, dispatch] = useContext(StoreContext)
  const { notificacionesNuevas, notificaciones } = store

/*
  const socket = io('http://localhost:3000') // Reemplaza con la URL de tu servidor de sockets
  useEffect(() => {
    // Eventos de sockets
    socket.on('connect', () => {})

    socket.on('front', (data) => {
      messageee({text:data.mensaje, icon:'success'})
    })
    return () => {
      socket.disconnect()
    }
  }, [])
*/
  const user = getUserData()
  const filtros = {
    sistema: "Web",
    destinatario: user?.rol ?? ''
  }
  const {
    load,
    addNotification,
    administrar,
    deleteNotificacion
  } = useNotificacion([])
  const navigate = useNavigate()

  const clickNotificacionHandler = (item) => {
    administrar(
      {
        _id: item._id,
        accion: 2,
        status: true
      },
      () => {
        navigate(item.rutaRedireccion, { state: {
          accion: 2,
          asesoria: item.data
        }})
        deleteNotificacion(item)
        dispatch({ type: types.setModuloActivo, payload: "asesorias" })
      })
  }

  useEffect(() => {}, [notificaciones])
  
  useEffect(() => {}, [])

  // ** Function to render Notifications
  /*eslint-disable */
  const renderNotificationItems = () => {
    return (
      <PerfectScrollbar
        component="li"
        className="media-list scrollable-container"
        options={{
          wheelPropagation: false
        }}
      >
        {notificaciones.map((item, index) => {
          return (
            <ItemDropdown
              key={'Item-' + index}
              indexItem={index}
              data={item}
              clickNotificacionHandler={clickNotificacionHandler}
            />
          )
        })}
      </PerfectScrollbar>
    )
  }
  /*eslint-enable */

  return (
    <UncontrolledDropdown
      tag="li"
      className="dropdown-notification nav-item me-25"
    >
      <DropdownToggle
        tag="a"
        className="nav-link"
        href="/"
        onClick={(e) => e.preventDefault()}
      >
        <Bell size={21} />
        <Badge pill color="danger" className="badge-up">
          {notificacionesNuevas.length}
        </Badge>
      </DropdownToggle>
      <DropdownMenu end tag="ul" className="dropdown-menu-media mt-0">
        <li className="dropdown-menu-header">
          <DropdownItem className="d-flex" tag="div" header>
            <h4 className="notification-title mb-0 me-auto">Notificaciones</h4>
            <Badge tag="div" color="light-primary" pill>
              {notificacionesNuevas.length}
            </Badge>
          </DropdownItem>
        </li>
        {renderNotificationItems()}
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default NotificationDropdown
